<template>
  <div class="swiper-outer">
    <swiper v-if="data.length" v-bind="options" @slideChange="change" @swiper="onSwiper" class="hotel-swiper">
      <swiper-slide v-for="(item, index) in data" :key="item.id" ref="r" class="swiper-slide">
        <div
          style="transform: translate3d(0, 0, 0)"
          class="cover"
          :style="{ backgroundImage: `url(${item.path})` }"
          @click="preview(index)"
        ></div>
      </swiper-slide>
    </swiper>
    <div class="numbers">{{ current + 1 }}/{{ data.length }}</div>
  </div>
</template>

<script>
import photoSwipe from 'kuan-vue-photoswipe'
import { Swiper, SwiperSlide } from '@/components/swiper'

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      current: 0,
    }
  },
  computed: {
    options() {
      return {
        loop: this.data.length > 1,
        spaceBetween: 5,
      }
    },
  },
  methods: {
    preview(index) {
      const images = this.data.map((item) => ({
        src: item.path,
        w: item.width,
        h: item.height,
      }))
      photoSwipe.preview(images, { index })
    },
    change(e) {
      this.current = e.realIndex
    },
    onSwiper(swiper) {
      this.swiper = swiper
    },
  },
}
</script>

<style lang="less" scoped>
.swiper-outer {
  position: relative;
  .hotel-swiper {
    width: 750px;
    height: 500px;
  }
  .cover {
    height: 500px;
    background-color: #eee;
  }
  .numbers {
    position: absolute;
    right: 22px;
    bottom: 22px;
    height: 38px;
    line-height: 38px;
    padding: 0 1em;
    background: rgba(#000000, 0.49);
    border-radius: 20px;
    font-size: 24px;
    color: white;
    z-index: 10;
  }
}
</style>
